import { useSite } from "@/context/SiteContext";
import { Section, GoldButton } from "@/components/site/Ui";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { mediaUrl } from "@/lib/api";

const ABOUT_IMG = "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function About() {
  const { settings } = useSite();
  const photo = settings.about_photo ? mediaUrl(settings.about_photo) : ABOUT_IMG;
  const paragraphs = (settings.about_text || "").split("\n").filter(Boolean);

  return (
    <div className="relative grain overflow-hidden">
      <Section>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <Eyebrow>About</Eyebrow>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">My story & mission</h1>
            <div className="mt-6 space-y-4 text-white/70 leading-relaxed text-[15px]">
              {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </div>
            <GoldButton as="link" to="/services#consultation" className="mt-8">Work with me</GoldButton>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative mx-auto w-full max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-gradient-to-tr from-[#D4AF37]/30 to-transparent blur-xl" />
              <div className="gold-frame relative shadow-2xl shadow-black/50">
                <div className="relative z-10 overflow-hidden rounded-[1.3rem]">
                  <img src={photo} alt="Founder of Qwerjoh Media" data-testid="about-photo" className="w-full aspect-[4/5] object-cover transition-transform duration-700 ease-out hover:scale-[1.04]" />
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </Section>
    </div>
  );
}
